import { z } from "zod";
import { alarmCategorySchema, alarmSeveritySchema, alarmStatusSchema, notificationKindSchema, } from "../alarms/enums.js";
import { defineEvent } from "./registry.js";
/**
 * Alarm ve bildirim olayları (Prompt 20, ADR 0020 §14). Yük KİŞİSEL VERİ TAŞIMAZ ve başlık / ileti içermez: istemci ayrıntıyı
 * yetki denetimli API'den çeker (alarmı görmek kuralın hedef iznini ister). Alarm olayları `tenant` + `station` odalarına
 * (şirket düzeyi alarmda `metadata.stationId` yoktur → yalnızca kiracı odası); bildirim olayı yalnızca `user` odasına
 * (`metadata.targetUserId`) gider.
 */
const alarmBase = {
    alarmId: z.uuid(),
    ruleCode: z.string(),
    category: alarmCategorySchema,
    severity: alarmSeveritySchema,
    status: alarmStatusSchema,
    companyId: z.uuid().nullable(),
    stationId: z.uuid().nullable(),
};
export const alarmRaisedV1 = defineEvent({
    type: "alarms.alarm.raised",
    version: 1,
    description: "Yeni alarm açıldı",
    realtime: ["tenant", "station"],
    payload: z.object({ ...alarmBase }),
});
export const alarmUpdatedV1 = defineEvent({
    type: "alarms.alarm.updated",
    version: 1,
    description: "Alarm güncellendi (yinelendi, önemi yükseldi, görüldü, atandı, not, yeniden açıldı)",
    realtime: ["tenant", "station"],
    payload: z.object({
        ...alarmBase,
        change: z.enum(["REPEATED", "SEVERITY_RAISED", "ACKNOWLEDGED", "ASSIGNED", "NOTE", "REOPENED"]),
        occurrenceCount: z.number().int().positive(),
    }),
});
export const alarmResolvedV1 = defineEvent({
    type: "alarms.alarm.resolved",
    version: 1,
    description: "Alarm çözüldü (elle ya da kendiliğinden)",
    realtime: ["tenant", "station"],
    payload: z.object({ ...alarmBase, autoResolved: z.boolean() }),
});
export const alarmEscalatedV1 = defineEvent({
    type: "alarms.alarm.escalated",
    version: 1,
    description: "Görülmeyen kritik alarm bir üst halkaya yükseltildi",
    realtime: ["tenant", "station"],
    payload: z.object({ ...alarmBase, escalationLevel: z.number().int().min(1) }),
});
export const notificationCreatedV1 = defineEvent({
    type: "notifications.notification.created",
    version: 1,
    description: "Kullanıcının bildirim kutusuna yeni bildirim düştü (zil)",
    realtime: ["user"],
    payload: z.object({
        notificationId: z.uuid(),
        userId: z.uuid(),
        kind: notificationKindSchema,
        severity: alarmSeveritySchema.nullable(),
        stationId: z.uuid().nullable(),
    }),
});
//# sourceMappingURL=alarms.v1.js.map